import styled from "styled-components";


export const ContainerPagination = styled.div`
    display: flex;
    width: 100%;
    padding: 25px;
    justify-content: center;
    align-items: center;
`;

export const RowContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PaginationButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
    outline: none;
    padding: 7px;
    color: #333;
    leading-trim: both;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 10px;
    min-width: 38px;
    height: 38px;
    ${props => props.$unpress && `
        opacity: 0.5;
        cursor: not-allowed;
    `}
    ${props => props.$press && `
        color: var(--white-100, #FFF);
        leading-trim: both;
        text-edge: cap;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        background: #3C9;
    `}
`;